import React from 'react';

const RulesPage = () => (
  <div className="rules-page">
    Rules
  </div>
);

export default RulesPage;